// @ts-nocheck
import { Component, Input, inject } from '@angular/core';
import { InputTextComponent } from '../fields/input-text/input-text.component';
import { DepositsService } from './deposits-panel.service';

@Component({
  selector: 'lbca-deposits-panel',
  templateUrl: './deposits-panel.component.html',
  imports: [InputTextComponent],
})
export class DepositsPanelComponent {
  private depositsService = inject(DepositsService);

  public baseDepositos: any;

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  private param: any;
  @Input('dataAttr') set data(data) {
    this.param = { processId: data.processNumber };
  }

  private value: any;
  @Input('value') set val(obj) {
    this.value = obj;
    setTimeout(() => this.updatePanel(), 2000);
  }

  updatePanel() {
    const data = this.value;
    const param = this.param;

    function loadPanel(resp) {
      return [
        [
          {
            label: 'Total Depósito Original',
            value: parseFloat(resp.valueBankDeposits).toFixed(2), //TotalDepositoOriginal
          },
          {
            label: 'Total Depósito Atualizado',
            value: parseFloat(resp.updatedValueBankDeposits).toFixed(2), //TotalDepositoAtualizado
          },
        ],
        [
          {
            label: 'Total Alvará',
            value: parseFloat(resp.historicValueSurvey).toFixed(2), //TotalLevantamentos
          },
          {
            label: 'Total Alvará Atualizado',
            value: parseFloat(resp.updatedValueSurvey).toFixed(2), //TotalLevantamentosAtualizados
          },
        ],
        [
          {
            label: 'Saldo Processual',
            value: parseFloat(resp.proceduralBalance).toFixed(2), //SaldoProcessual
          },
          {
            label: 'Saldo Processual Atualizado',
            value: parseFloat(resp.proceduralBalanceUpdate).toFixed(2), //SaldoProcessualAtualizado
          },
        ],
        [
          {
            label: 'Saldo Processual Alvará Retirado',
            value: parseFloat(resp.proceduralBalanceWithdrawn).toFixed(2), //SaldoProcessualAlvaraRetirado
          },
          {
            label: 'Saldo Processual Alvará Retirado Atualizado',
            value: parseFloat(resp.proceduralBalanceWithdrawnUpdated).toFixed(2), //SaldoProcessualAlvaraRetiradoAtualizado
          },
        ],
        [
          {
            label: 'Saldo Processual Alvará Não Retirado',
            value: parseFloat(resp.proceduralnotWithdrawn).toFixed(2), //SaldoProcessualAlvaraNaoRetirado
          },
          {
            label: 'Saldo Processual Alvará Não Retirado Atualizado',
            value: parseFloat(resp.proceduralnotWithdrawnUpdated).toFixed(2), //SaldoProcessualAlvaraNaoRetiradoAtualizado
          },
        ],
      ];
    }

    this.depositsService
      .deposits(data, param)
      .subscribe((resp) => (this.baseDepositos = loadPanel(resp)));
  }
}

const mock = [
  {
    index: 1,
    id: '403db1f0-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819246,
    typeBankDeposits: '1',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1457478000,
    valueBankDeposits: '8183.06',
    updatedValueBankDeposits: '12078.27',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
  },
  {
    index: 2,
    id: '7fae1500-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819353,
    typeBankDeposits: '1',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1479855600,
    valueBankDeposits: '17920.00',
    updatedValueBankDeposits: '25557.95',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
  },
  {
    index: 3,
    id: '92d81680-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819385,
    typeBankDeposits: '1',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1496095200,
    valueBankDeposits: '8959.63',
    updatedValueBankDeposits: '12503.41',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
  },
  {
    index: 4,
    id: 'a8a12ce0-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: true,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819421,
    typeBankDeposits: '1',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1512687600,
    valueBankDeposits: '18378.00',
    updatedValueBankDeposits: '25141.64',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
    survey: [
      {
        id: '86f5d4f0-326b-11ec-82c6-a970f7bf5986',
        user: 'Felipe Vicente',
        createDate: 1634819794,
        expetidionSurvey: '1',
        withDrawalSurvey: '3',
        hasSurvey: 'true',
        typeSurvey: '290',
        dateWithDrawalSurvey: 1613084400,
        historicValueSurvey: '40269.85',
        updatedValueSurvey: '41082.33',
        whoSurvey: '',
        lawyerNameSurvey: '',
        moduleSurveyGuide: '',
        UFSurvey: '',
        bankSurvey: '',
        agencySurvey: '',
        bankAccountSurvey: '',
        index: 1,
        edit: false,
        remove: false,
        opened: false,
        confirmDelete: false,
      },
    ],
  },
  {
    index: 5,
    id: 'c069e3d0-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819461,
    typeBankDeposits: '15',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1512687600,
    valueBankDeposits: '181.34',
    updatedValueBankDeposits: '181.34',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
  },
  {
    index: 6,
    id: 'cf5c0800-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819486,
    typeBankDeposits: '15',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1512687600,
    valueBankDeposits: '126.40',
    updatedValueBankDeposits: '126.40',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
  },
  {
    index: 7,
    id: 'e50bca00-326a-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819523,
    typeBankDeposits: '5',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1521414000,
    valueBankDeposits: '1205473.74',
    updatedValueBankDeposits: '1636813.31',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
    survey: [
      {
        id: '2932fe60-326b-11ec-82c6-a970f7bf5986',
        user: 'Felipe Vicente',
        createDate: 1634819637,
        expetidionSurvey: '1',
        withDrawalSurvey: '3',
        hasSurvey: 'true',
        typeSurvey: '291',
        dateWithDrawalSurvey: 1603666800,
        historicValueSurvey: '876440.67',
        updatedValueSurvey: '903098.45',
        whoSurvey: '',
        lawyerNameSurvey: '',
        moduleSurveyGuide: '',
        UFSurvey: '',
        bankSurvey: '',
        agencySurvey: '',
        bankAccountSurvey: '',
        index: 1,
        edit: false,
        remove: false,
        opened: false,
        confirmDelete: false,
      },
      {
        id: '56edfe90-326b-11ec-82c6-a970f7bf5986',
        user: 'Felipe Vicente',
        createDate: 1634819714,
        expetidionSurvey: '1',
        withDrawalSurvey: '3',
        hasSurvey: 'true',
        typeSurvey: '291',
        dateWithDrawalSurvey: 1603666800,
        historicValueSurvey: '319927.61',
        updatedValueSurvey: '329658.52',
        whoSurvey: null,
        lawyerNameSurvey: null,
        moduleSurveyGuide: null,
        UFSurvey: null,
        bankSurvey: null,
        agencySurvey: null,
        bankAccountSurvey: null,
        index: 2,
        edit: false,
        remove: false,
        opened: false,
        confirmDelete: false,
      },
    ],
  },
  {
    index: 8,
    id: 'c536b8b0-326b-11ec-82c6-a970f7bf5986',
    edit: false,
    remove: false,
    opened: false,
    confirmDelete: false,
    user: 'Felipe Vicente',
    createDate: 1634819899,
    typeBankDeposits: '14',
    phaseBankDeposits: '',
    warrantyBankDeposits: '',
    dateBankDeposits: 1633903200,
    valueBankDeposits: '0.01',
    updatedValueBankDeposits: '0.01',
    moduleGuide: '',
    whoDepositedBankDeposits: '',
    bankDepositedBankDeposits: '',
    agencyBankDeposits: '',
    bankAccountBankDeposits: '',
    moduleExtract: '',
    dateBalanceBankDeposits: '',
    valueBalanceBankDeposits: '',
    bankDepositedBalanceBankDeposits: '',
  },
];
